import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QIcon from "../icon/QIcon.js";
import QSpinner from "../spinner/QSpinner.js";
import TouchPan from "../../directives/TouchPan.js";
import ListenersMixin from "../../mixins/listeners.js";
import { getScrollTarget, getScrollPosition } from "../../utils/scroll.js";
import { between } from "../../utils/format.js";
import { prevent } from "../../utils/event.js";
import { slot } from "../../utils/slot.js";
var PULLER_HEIGHT = 40,
    OFFSET_TOP = 20;
export default Vue.extend({
  name: 'QPullToRefresh',
  mixins: [ListenersMixin],
  directives: {
    TouchPan: TouchPan
  },
  props: {
    color: String,
    bgColor: String,
    icon: String,
    noMouse: Boolean,
    disable: Boolean,
    scrollTarget: {
      default: void 0
    }
  },
  data: function data() {
    return {
      state: 'pull',
      pullRatio: 0,
      pulling: false,
      pullPosition: -PULLER_HEIGHT,
      animating: false,
      positionCSS: {}
    };
  },
  computed: {
    style: function style() {
      return {
        opacity: this.pullRatio,
        transform: "translateY(".concat(this.pullPosition, "px) rotate(").concat(this.pullRatio * 360, "deg)")
      };
    },
    classes: function classes() {
      return 'q-pull-to-refresh__puller row flex-center' + (this.animating === true ? ' q-pull-to-refresh__puller--animating' : '') + (this.bgColor !== void 0 ? " bg-".concat(this.bgColor) : '');
    },
    directives: function directives() {
      if (this.disable !== true) {
        var modifiers = {
          down: true,
          mightPrevent: true
        };

        if (this.noMouse !== true) {
          modifiers.mouse = true;
        }

        return [{
          name: 'touch-pan',
          modifiers: modifiers,
          value: this.__pull
        }];
      }
    },
    contentClass: function contentClass() {
      return "q-pull-to-refresh__content".concat(this.pulling === true ? ' no-pointer-events' : '');
    }
  },
  watch: {
    scrollTarget: function scrollTarget() {
      this.updateScrollTarget();
    }
  },
  methods: {
    trigger: function trigger() {
      var _this = this;

      this.$emit('refresh', function () {
        _this.__animateTo({
          pos: -PULLER_HEIGHT,
          ratio: 0
        }, function () {
          _this.state = 'pull';
        });
      });
    },
    updateScrollTarget: function updateScrollTarget() {
      this.__scrollTarget = getScrollTarget(this.$el, this.scrollTarget);
    },
    __pull: function __pull(event) {
      if (event.isFinal === true) {
        if (this.pulling === true) {
          this.pulling = false;

          if (this.state === 'pulled') {
            this.state = 'refreshing';

            this.__animateTo({
              pos: OFFSET_TOP
            });

            this.trigger();
          } else if (this.state === 'pull') {
            this.__animateTo({
              pos: -PULLER_HEIGHT,
              ratio: 0
            });
          }
        }

        return;
      }

      if (this.animating === true || this.state === 'refreshing') {
        return false;
      }

      if (event.isFirst === true) {
        if (getScrollPosition(this.__scrollTarget) !== 0 || event.direction !== 'down') {
          if (this.pulling === true) {
            this.pulling = false;
            this.state = 'pull';

            this.__animateTo({
              pos: -PULLER_HEIGHT,
              ratio: 0
            });
          }

          return false;
        }

        this.pulling = true;

        var _this$$el$getBounding = this.$el.getBoundingClientRect(),
            top = _this$$el$getBounding.top,
            left = _this$$el$getBounding.left;

        this.positionCSS = {
          top: top + 'px',
          left: left + 'px',
          width: window.getComputedStyle(this.$el).getPropertyValue('width')
        };
      }

      prevent(event.evt);
      var distance = Math.min(140, Math.max(0, event.distance.y));
      this.pullPosition = distance - PULLER_HEIGHT;
      this.pullRatio = between(distance / (OFFSET_TOP + PULLER_HEIGHT), 0, 1);
      var state = this.pullPosition > OFFSET_TOP ? 'pulled' : 'pull';

      if (this.state !== state) {
        this.state = state;
      }
    },
    __animateTo: function __animateTo(_ref, done) {
      var _this2 = this;

      var pos = _ref.pos,
          ratio = _ref.ratio;
      this.animating = true;
      this.pullPosition = pos;

      if (ratio !== void 0) {
        this.pullRatio = ratio;
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.animating = false;
        done && done();
      }, 300);
    }
  },
  mounted: function mounted() {
    this.updateScrollTarget();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer);
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'q-pull-to-refresh',
      on: _objectSpread({}, this.qListeners),
      directives: this.directives
    }, [h('div', {
      class: this.contentClass
    }, slot(this, 'default')), h('div', {
      staticClass: 'q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top',
      style: this.positionCSS
    }, [h('div', {
      style: this.style,
      class: this.classes
    }, [this.state !== 'refreshing' ? h(QIcon, {
      props: {
        name: this.icon || this.$q.iconSet.pullToRefresh.icon,
        color: this.color,
        size: '32px'
      }
    }) : h(QSpinner, {
      props: {
        size: '24px',
        color: this.color
      }
    })])])]);
  }
});